// extracted by mini-css-extract-plugin
export default {"notification-bottom":"style_notification-bottom__SnTWE","notificationBottom":"style_notification-bottom__SnTWE"};